import React from "react";
import { Drawer } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai"; // Importing the close icon from react-icons

function ProductDrawer({ openDrawer, setOpenDrawer, selectedProduct }) {
  return (
    <Drawer
      anchor="right"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{ width: "400px" }}
    >
      <div className="p-6 w-96 bg-white shadow-lg rounded-lg relative">
        {/* Close Icon */}
        <button
          onClick={() => setOpenDrawer(false)}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 transition-transform transform hover:scale-110"
        >
          <AiOutlineClose size={24} />
        </button>

        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Product Details</h3>
        <div className="py-4">
          {selectedProduct && (
            <div>
              <img
              src={`data:${selectedProduct?.image?.contentType};base64,${selectedProduct?.image?.data}`}
              alt={selectedProduct.name}
                className="w-60 h-60 object-cover rounded-lg mb-4"
              />
              {/* Product Name */}
              <div className="mb3">
                <h4 className="font-medium text-lg text-gray-700">Name:</h4>
                <p className="text-gray-800">{selectedProduct.name}</p>
              </div>

              {/* Product Description */}
              <div className="mb-3">
                <h4 className="font-medium text-lg text-gray-700">Description:</h4>
                <p className="text-gray-600">{selectedProduct.description}</p>
              </div>

              {/* Price */}
              <div className="mb-3">
                <h4 className="font-medium text-lg text-gray-700">Price:</h4>
                <p className="text-xl font-semibold text-gray-800">${selectedProduct.price}</p>
              </div>

              {/* Category and Subcategory */}
              <div className="mb-4">
                <h4 className="font-medium text-lg text-gray-700">Category:</h4>
                <p className="text-gray-800">{selectedProduct.category.name}</p>
                <h4 className="font-medium text-lg text-gray-700 mt-2">Subcategory:</h4>
                <p className="text-gray-800">{selectedProduct.subcategory.name}</p>
              </div>

              {/* Specifications */}
              {selectedProduct.specifications && selectedProduct.specifications.length > 0 && (
                <div className="mb-4">
                  <h4 className="font-medium text-lg text-gray-700">Specifications:</h4>
                  <ul className="list-disc ml-6 text-gray-600">
                    {selectedProduct.specifications.map((spec, index) => (
                      <li key={index}>
                        <strong>{spec.key}:</strong> {spec.value}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
}

export default ProductDrawer;
